import adminHttp from "@/api/adminHttp";

const END_POINT = "/api/admin/watch";

export default {
    index: (watchId) => adminHttp.get(`${END_POINT}/${watchId}/cheers`),
    sync: (watchId, params) => adminHttp.put(`${END_POINT}/${watchId}/cheers/sync`, params),
    toggle: (watchId) => adminHttp.patch(`${END_POINT}/${watchId}/cheers/toggle`),
}
